import React from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import technologyPartners from "@/data/technology-partner.json";
import fulfillmentPartners from "@/data/fulfillment-partner.json";
import Link from "next/link";
import { MdArrowForward } from "react-icons/md";
import { routes } from "@/utils/routes";
import classes from "@/styles/partners/partners-main.module.css";
import Image from "next/image";

const topThreeFeaturedTechnologies = technologyPartners
  .filter((partner) => partner.isFeatured)
  .slice(0, 3);
const topThreeFeaturedFulfillments = fulfillmentPartners
  .filter((partner) => partner.isFeatured && !partner.comingSoon)
  .slice(0, 3);

const PartnersMain = () => {
  return (
    <>
      <section className={classes.container}>
        <div className={classes.hero}>
          <h1>ShipVista Partners</h1>
          <p>
            ShipVista has integrations with many technology platforms to offer
            its services
          </p>
        </div>
        <Container>
          <main className="my-5">
            <h3 className={classes.title}>Technology Partners</h3>
            <Card className={classes.cardMain}>
              <Row>
                {topThreeFeaturedTechnologies.map(
                  ({ name, url, logoPath, desc }) => (
                    <Col className="py-2" xs={12} lg={3} key={name}>
                      <Link href={"/partners" + url}>
                        <Card className={classes.innerCard}>
                          <div
                            className={`${classes.cardImgHeader} border-bottom`}
                          >
                            <Image
                              height={200}
                              width={200}
                              src={logoPath}
                              alt={name}
                              className="img-fluid"
                            />
                          </div>
                          <CardBody>
                            <div
                              className={`py-2 px-3 flex-grow-1 d-flex flex-column justify-content-between cardBody`}
                            >
                              <div>
                                <h6 className="text-secondary">{name}</h6>
                                <p className="text-secondary">{desc}</p>
                              </div>
                              <p
                                className={`text-center text-secondary mx-auto ${classes.cardLink}`}
                              >
                                Learn More&nbsp;
                                <MdArrowForward />
                              </p>
                            </div>
                          </CardBody>
                        </Card>
                      </Link>
                    </Col>
                  )
                )}
                <Col xs={12} lg={3}>
                  <div className={classes.emptyCard}>
                    <Link
                      href={routes.technologyPartner}
                      className={`moreCard`}
                    >
                      See more &nbsp;
                      <MdArrowForward />
                    </Link>
                  </div>
                </Col>
              </Row>
            </Card>
            {topThreeFeaturedTechnologies.length < 3 &&
              [...new Array(3 - topThreeFeaturedTechnologies.length)].map(
                (_, i) => <div key={i} style={{ opacity: "0" }} />
              )}

            <h3 className={classes.title}>Fulfillment Partners</h3>
            <div>
              <Card className={classes.cardMain}>
                <Row>
                  {topThreeFeaturedFulfillments.map(
                    ({ name, url, logoPath, desc }) => (
                      <Col className="py-2" xs={12} lg={3} key={name}>
                        <Link href={"/partners" + url}>
                          <Card className={classes.innerCard}>
                            <div
                              className={`${classes.cardImgHeader} border-bottom`}
                            >
                              <Image
                                height={100}
                                width={180}
                                src={logoPath}
                                alt={name}
                              />
                            </div>
                            <CardBody>
                              <div
                                className={`py-2 px-3 flex-grow-1 d-flex flex-column justify-content-between cardBody `}
                              >
                                <div>
                                  <h6 className="text-secondary">{name}</h6>
                                  <p className="text-secondary">{desc}</p>
                                </div>
                                <p
                                  className={`text-center text-secondary mx-auto ${classes.cardLink}`}
                                >
                                  Learn More&nbsp;
                                  <MdArrowForward />
                                </p>
                              </div>
                            </CardBody>
                          </Card>
                        </Link>
                      </Col>
                    )
                  )}
                  <Col xs={12} lg={3}>
                    <div className={classes.emptyCard}>
                      <Link
                        href={routes.fulfillmentPartners}
                        className={`moreCard`}
                      >
                        See more
                        <MdArrowForward />
                      </Link>
                    </div>
                  </Col>
                </Row>
              </Card>
              {topThreeFeaturedFulfillments.length < 3 &&
                [...new Array(3 - topThreeFeaturedFulfillments.length)].map(
                  (_, i) => <div key={i} style={{ opacity: "0" }} />
                )}
            </div>
          </main>
        </Container>
      </section>
    </>
  );
};

export default PartnersMain;
